//export const API_REPORTER_BASE_URL = "https://4cxxz2c5-8004.inc1.devtunnels.ms/api/v1/reporter"; 


// export const API_REPORTER_BASE_URL = "https://newsapp.aasmo.in/api/v1/reporter"; 
export const API_REPORTER_BASE_URL = " https://backend.xpressnews.in/api/v1/reporter";

export const API_REPORTER_ENDPOINT = {
  // News Creation
  CREATE_NEWS: `${API_REPORTER_BASE_URL}/news`,
   UPLOAD_MEDIA:`${API_REPORTER_BASE_URL}/upload-media`,
  // Public Lookups (Categories, Subcategories, etc. - can be accessed by reporter)
  GET_ALL_CATEGORIES: `${API_REPORTER_BASE_URL}/categories`,
  GET_ALL_SUBCATEGORIES: `${API_REPORTER_BASE_URL}/subcategories`,

  // For Reporter's "My News" list (if implemented later)
  GET_MY_NEWS: `${API_REPORTER_BASE_URL}/getNewsByReporter`,
    // UPDATE_NEWS: (id) => `${API_REPORTER_BASE_URL}/getNewsByReporter/${id}`, 
        UPDATE_NEWS:  `${API_REPORTER_BASE_URL}/getNewsByReporter`,
        DELETE_NEWS :`${API_REPORTER_BASE_URL}/getNewsByReporter`,

        CREATE_SHORT:`${API_REPORTER_BASE_URL}/shorts`,
        GET_MY_SHORTS:`${API_REPORTER_BASE_URL}/getMyShorts`,

};